@if (selectionService.isFilterModalOpen()) {
    <mat-chip-row (removed)="closeGeographicFilter()">
        <span class="text-custom-blue text-base">{{ 'geographicFilter' | transloco }}</span>
        <button matChipRemove>
            <mat-icon color="warn">cancel</mat-icon>
        </button>
    </mat-chip-row>
} @else {
    <app-button
        [icon]="['fas', 'vector-square']"
        [label]="'geographicFilter' | transloco"
        [type]="selectionService.isFilterModalOpen() ? ButtonType.PRIMARY : ButtonType.SECONDARY"
        (onClick)="toggleGeographicFilter()" />
}
